import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const importSubaccounts = (investor_id) => request.post(`${API_BASE_URL}/blockchain/green-wallet/import-subaccounts`, { investor_id })

export default importSubaccounts;